import { Checkbox } from "@mui/material";

import { LineTableCell } from "components/formFields/LineTableCell";

export function LineTax(props) {
  const { value, customer, onValueChange, lineReadOnly = false } = props;

  const isDisabled = customer && !customer.tax?.taxable;

  return (
    <LineTableCell>
      <div style={{ width: "100%", display: "inline-block" }}>
        <div style={{ textAlign: "center" }}>
          <Checkbox
            key={value}
            name="tax"
            checked={value}
            onChange={(e) => onValueChange("tax", e.target.checked)}
            disabled={isDisabled || lineReadOnly}
            data-testing="lineTax"
          />
        </div>
      </div>
    </LineTableCell>
  );
}
